import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteVoidAtom = createMutationAtomFactory(
  'brokerage.quoteVoid',
  (params: { id: string }) => ({
    tradeQuoteVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
